import api from "../../api";

export const postWaitlist = async (data : {
    id : string
    notificationId ?: string,
}) => {
    const res = await api.put(`events/${data.id}/waiting_list/`)
    return res.data
}


export const deleteWaitlist = async (data : {
    id : string,
    notificationId ?: string,
}) => {
    const res = await api.delete(`events/${data.id}/waiting_list/`)
    return res.data
}

export const validatePrivateCode = async (data : {
    id : string,
    private_code : string,
}) => {
    const res = await api.get(`events/${data.id}/join/`, { params : {
        private_code : data.private_code
    } })
    return res.data
}